import { render } from "./edit.vue?vue&type=template&id=3ef66b7c"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=3ef66b7c&style=scss&lang=css"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/apartment/province/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ef66b7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ef66b7c', __exports__)) {
    console.log('reload')
    api.reload('3ef66b7c', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=3ef66b7c", () => {
    console.log('re-render')
    api.rerender('3ef66b7c', render)
  })

}


export default __exports__